import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import LanguageContext from "components/LanguageContext";
import AllNewsSearch from "components/templates/news/AllNewsSearch";
import ModalTagsBlock from "components/templates/news/ModalTagsBlock";
import SelectTagsBlock from "components/templates/news/SelectTagsBlock";
import InputDSFR from "components/templatesComponents/InputDSFR";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { dateNowFormatted } from "utils/commonUtils";
import t from "utils/locales/translation.json";

const AllNewsFilters = (props) => {
  const {
    value,
    setValue,
    profilTags = [],
    thematicTags = [],
    selectedProfilTags = [],
    selectedTagsForm,
    startDate,
    endDate,
    validStartDate,
    validEndDate,
    handleSelectProfilTags,
    handleSelectTagsForm,
    handleChangeDate,
    isMobile = false,
  } = props;

  const { language } = useContext(LanguageContext);

  const inputStartDateId = useMemo(() => (isMobile ? "start-date-mobile" : "start-date"), [isMobile]);
  const inputEndDateId = useMemo(() => (isMobile ? "end-date-mobile" : "end-date"), [isMobile]);

  const filteredProfilTags = useMemo(() => {
    const newProfilTags = [];

    profilTags.filter((tag) => {
      const key = tag.toLocaleLowerCase();
      if (!newProfilTags.includes(key)) {
        newProfilTags.push(key);
      }
    });
    return newProfilTags;
  }, [profilTags]);

  const filteredThematicTags = useMemo(() => {
    const newThematicTags = [];

    thematicTags.filter((tag) => {
      const key = tag.toLocaleLowerCase();
      if (!newThematicTags.includes(key)) {
        newThematicTags.push(key);
      }
    });
    return newThematicTags;
  }, [thematicTags]);

  return (
    <>
      <AllNewsSearch value={value} setValue={setValue} isMobile={isMobile} />
      <Box sx={{ "& .fr-text--bold": { mt: 3, mb: 2 } }}>
        {filteredProfilTags.length > 0 &&
          (isMobile ? (
            <ModalTagsBlock
              label={t[language].all_news.profil_filter_title}
              allTags={filteredProfilTags}
              selectedTags={selectedProfilTags}
              handleSelectTagsForm={handleSelectProfilTags}
            />
          ) : (
            <SelectTagsBlock
              label={t[language].all_news.profil_filter_title}
              allTags={filteredProfilTags}
              selectedTags={selectedProfilTags}
              handleSelectTagsForm={handleSelectProfilTags}
            />
          ))}
        {filteredThematicTags.length > 0 &&
          (isMobile ? (
            <ModalTagsBlock
              label={t[language].all_news.theme_filter_title}
              allTags={filteredThematicTags}
              selectedTags={selectedTagsForm}
              handleSelectTagsForm={handleSelectTagsForm}
            />
          ) : (
            <SelectTagsBlock
              label={t[language].all_news.theme_filter_title}
              allTags={filteredThematicTags}
              selectedTags={selectedTagsForm}
              handleSelectTagsForm={handleSelectTagsForm}
            />
          ))}
        <fieldset className="fr-fieldset" id="date-filter-fieldset" role="group" aria-labelledby="date-filter-legend">
          <legend className="fr-fieldset__legend" id="date-filter-legend">
            {t[language].all_news.date_filter_title}
          </legend>
          <Stack sx={{ width: "100%", px: 1 }}>
            <InputDSFR
              label={t[language].all_news.start_date_label}
              id={inputStartDateId}
              name="startDate"
              value={startDate}
              type="date"
              min="2019-01-01"
              max={validEndDate ? endDate : dateNowFormatted}
              onChange={handleChangeDate}
            />
            <InputDSFR
              label={t[language].all_news.end_date_label}
              id={inputEndDateId}
              name="endDate"
              value={endDate}
              type="date"
              min={validStartDate ? startDate : "2019-01-01"}
              max={dateNowFormatted}
              onChange={handleChangeDate}
            />
          </Stack>
        </fieldset>
      </Box>
    </>
  );
};

AllNewsFilters.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  profilTags: PropTypes.arrayOf(PropTypes.string),
  thematicTags: PropTypes.arrayOf(PropTypes.string),
  selectedProfilTags: PropTypes.arrayOf(PropTypes.string),
  selectedTagsForm: PropTypes.shape().isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  validStartDate: PropTypes.string.isRequired,
  validEndDate: PropTypes.string.isRequired,
  handleSelectProfilTags: PropTypes.func.isRequired,
  handleSelectTagsForm: PropTypes.func.isRequired,
  handleChangeDate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default AllNewsFilters;
